<template>
    <v-container fluid grid-list-md>
        <user-announcements></user-announcements>
    </v-container>
</template>
<script>
import UserAnnouncements from '@/components/Announcements/UserList.vue';
export default {
    components: {
      UserAnnouncements
    }
};
</script>
